import { Box, Typography } from "@mui/material";
import {
  Info as InfoIcon,
  Update as UpdateIcon,
  Verified as VerifiedIcon,
} from "@mui/icons-material";
import GlobalHeader from "../../components/header";
import { Link } from "react-router-dom";

export default function AcercaDeView() {
  return (
    <>
      <GlobalHeader />
      <Box sx={{ p: 3 }}>
        <Typography
          variant="h4"
          sx={{ display: "flex", alignItems: "center", mb: 2 }}
        >
          <InfoIcon sx={{ mr: 1 }} /> Acerca de este software
        </Typography>
        <Typography
          variant="body1"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <VerifiedIcon sx={{ mr: 1 }} /> Este software ha sido diseñado para
          ofrecer una solución eficiente para la gestión de pedidos y productos
          de PollosTeo, facilitando el control de inventario y la atención de
          clientes.
        </Typography>
        <Typography
          variant="body1"
          sx={{ display: "flex", alignItems: "center", mb: 1 }}
        >
          <UpdateIcon sx={{ mr: 1 }} /> Versión actual: 1.1.0 SW PollosTeo
        </Typography>
        <Typography
          component={Link}
          sx={{ textDecoration: "underline" }}
          to="/about/versions"
        >
          Versiones anteriores
        </Typography>
      </Box>
    </>
  );
}
